import {
  handleMainSectionDrop,
  handleQuestionDrop,
  handleSubSectionDrop,
  reorderMainSectionsByIndex,
  reorderSectionQuestions,
  reorderSubSectionsByIndex,
  resolveMainSectionId,
  resolveQuestionId,
  resolveSubSectionId,
} from './create_sections_reorder_helpers.js';

export const create_sections_reorder_methods = {
  handle_drag_over(event) {
    event.preventDefault();
    if (event?.dataTransfer) event.dataTransfer.dropEffect = 'move';
  },

  handle_main_section_drag_start(event, main_section, main_section_index) {
    if (this.reordering_main_sections) return;
    if (event?.dataTransfer) {
      event.dataTransfer.effectAllowed = 'move';
      event.dataTransfer.setData('text/plain', String(resolveMainSectionId(main_section, main_section_index)));
    }
    this.dragged_main_section = {
      main_section_id: resolveMainSectionId(main_section),
      main_section_index,
    };
  },

  handle_main_section_drag_end() {
    this.dragged_main_section = null;
  },

  async handle_main_section_drop(target_main_section, target_index) {
    if (!this.dragged_main_section || this.reordering_main_sections) return;
    await handleMainSectionDrop(this, target_main_section, target_index);
  },

  async reorder_main_sections_by_index(source_index, target_index) {
    if (this.reordering_main_sections) return;
    await reorderMainSectionsByIndex(this, source_index, target_index);
  },

  handle_sub_section_drag_start(event, main_section, sub_section, sub_section_index) {
    if (this.reordering_sub_sections) return;
    if (event?.dataTransfer) {
      event.dataTransfer.effectAllowed = 'move';
      event.dataTransfer.setData('text/plain', String(resolveSubSectionId(sub_section, sub_section_index)));
    }
    this.dragged_sub_section = {
      main_section_id: resolveMainSectionId(main_section),
      section_id: resolveSubSectionId(sub_section),
      sub_section_index,
    };
  },

  handle_sub_section_drag_end() {
    this.dragged_sub_section = null;
  },

  async handle_sub_section_drop(main_section, target_sub_section, target_index) {
    if (!this.dragged_sub_section || this.reordering_sub_sections) return;
    await handleSubSectionDrop(this, main_section, target_sub_section, target_index);
  },

  async reorder_sub_sections_by_index(main_section, source_index, target_index) {
    if (this.reordering_sub_sections) return;
    await reorderSubSectionsByIndex(this, main_section, source_index, target_index);
  },

  handle_question_drag_start(event, section, question, question_index) {
    if (this.reordering_section_questions) return;
    if (event?.dataTransfer) {
      event.dataTransfer.effectAllowed = 'move';
      event.dataTransfer.setData('text/plain', String(resolveQuestionId(question, question_index)));
    }
    this.dragged_question = {
      section_id: resolveSubSectionId(section),
      question_id: resolveQuestionId(question),
      question_index,
    };
  },

  handle_question_drag_end() {
    this.dragged_question = null;
  },

  async handle_question_drop(section, target_question, target_index) {
    if (!this.dragged_question || this.reordering_section_questions) return;
    await handleQuestionDrop(this, section, target_question, target_index);
  },

  async reorder_section_questions(section, source_index, target_index) {
    await reorderSectionQuestions(this, section, source_index, target_index);
  },
};
